export enum ReferenceSkuType {
    Ordinary,
    Deposit,
    TotalValue
}
